/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography } from '../../../styles/typography';

export const headlineCss = css(typography.effra28, {
  backgroundSize: '2px 1em',
  display: 'block',
  hyphens: 'auto',
  wordBreak: 'break-word',
});

export const ctaArrowCss = css({
  paddingLeft: 10,
  paddingRight: 10,
  color: colorsPalette.red,
  verticalAlign: 'middle',
});

export const priceCss = css(typography.effra16, {
  color: colorsPalette.grey80,
});

export const priceLightCss = css({
  color: colorsPalette.white,
});

export const bodyCss = css(typography.effra16, {
  marginBottom: 20,
  marginTop: 32,
});

export const goodForTitleCss = css({
  padding: '10px 0',
  display: 'inline-block',
});

export const goodForCss = css({
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  marginRight: 10,
  marginBottom: 8,
  paddingBottom: 5,
  display: 'inline-block',
  [MediaQueries.lgAndUp]: {
    borderBottom: 0,
  },
});

export const goodForBlackCss = css({
  borderBottom: `1px solid rgba(101, 101, 102, 0.3)`,
  color: colorsPalette.white,
  paddingBottom: 5,
  [MediaQueries.lgAndUp]: {
    borderBottom: 0,
  },
});

export const chevronCss = css({
  fontSize: 8,
  [MediaQueries.mdAndUp]: {
    fontSize: 10,
  },
});

export const chevronRotatedCss = css({
  transform: 'rotate(180deg)',
});

export const goodForBlackCaretCss = css({
  color: colorsPalette.white,
});

export const goodForWrapper = css({
  height: 0,
});

export const goodForOuterWrapper = css({
  marginTop: 40,
});

export const goodForExpandedCss = css({
  display: 'block',
  height: '100%',
});

export const goodForItemsListCss = css({
  display: 'none',
  [MediaQueries.lgAndUp]: {
    marginBottom: 27,
  },
});

export const goodForItemsListExpandedCss = css({
  display: 'block',
});

export const goodForItemCss = css({
  margin: '8px 0',
  display: 'flex',
});

export const itemCheckCss = css({
  color: colorsPalette.red,
  marginRight: 13,
  paddingTop: 3,
  fontSize: 12,
});

export const buttonResetCss = css({
  backgroundColor: colorsPalette.transparent,
  border: 'none',
  cursor: 'pointer',
  margin: 0,
  padding: 0,
});

export const ctaCss = isDarkMode =>
  css({
    alignItems: 'center',
    color: isDarkMode ? colorsPalette.white : colorsPalette.red,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  });

export const ctaLabelCss = isDarkMode =>
  css(typography.effra18, {
    lineHeight: 1.67,
    borderBottom: `1px solid ${
      isDarkMode ? colorsPalette.grey90 : colorsPalette.red20
    }`,
  });
